/* NAVIFORCE collection pages: style quick filters (client-side, based on product titles shown in the grid). */
(function(){
  var root = document.querySelector('[data-nf-coll]');
  if(!root) return;
  var chips = root.querySelectorAll('.nf-chip');
  var countNum = root.querySelector('[data-nf-count-num]');
  var countLabel = root.querySelector('[data-nf-count-label]');
  var countBox = root.querySelector('[data-nf-count]');
  var active = '';

  function items(){ return document.querySelectorAll('.m-collection-products .m-product-item'); }
  function titleOf(item){
    var a = item.querySelector('.m-product-card__name, .m-product-card__title');
    return ((a && a.textContent) || '').toLowerCase();
  }
  function apply(){
    var list = items(), shown = 0;
    var kws = active ? active.split('|') : [];
    Array.prototype.forEach.call(list, function(it){
      var t = titleOf(it);
      var ok = !kws.length || kws.some(function(k){ return t.indexOf(k) !== -1; });
      it.hidden = !ok;
      it.style.display = ok ? '' : 'none';
      if(ok) shown++;
    });
    if(countNum && chips.length){
      var total = parseInt(countBox.getAttribute('data-total'), 10) || 0;
      var n = active ? shown : total;
      countNum.textContent = n;
      countLabel.textContent = (n === 1 ? 'watch' : 'watches') + (active ? ' shown' : ' available');
    }
  }
  Array.prototype.forEach.call(chips, function(c){
    c.addEventListener('click', function(){
      active = c.getAttribute('data-nf-kw') || '';
      Array.prototype.forEach.call(chips, function(o){
        var on = o === c;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    });
  });
  var grid = document.querySelector('.m-collection-products');
  if(grid && chips.length && 'MutationObserver' in window){
    var host = grid.parentNode;
    new MutationObserver(function(){ if(active) apply(); }).observe(host, {childList:true, subtree:true});
  }
})();
